module.exports = __webpack_public_path__ + "img/Stack-Barrels.91720d53.png";